import { FortuneWheelSegmentsType, Language, PriceType, StreakDay } from '@app/shared/types/common';

export const NODE_ENV = import.meta.env.NODE_ENV as string;
export const APP_ENV = import.meta.env.VITE_APP_ENV as string;
export const APP_ENV_UPPER = APP_ENV.toUpperCase().slice(0, 3);

export const TUTORIAL_PENDING_KEY = 'app:tutorial:__pending__';

export const SESSION_STORAGE = {
  telegramInitData: 'telegramInitData',
} as const;

export const LOCAL_STORAGE = {
  cardUsedAt: 'cardUsedAt',
  energyUsedAt: 'energyUsedAt',
  cardDailyUseAt: 'cardDailyUseAt',
  media: 'media',
  details: 'details',
  gift: 'gift',
  tutorialKey: (userId: number) => `app:tutorial:${String(userId)}`,
} as const;

export const INITIAL_REWARD = '𝟐𝟎';

export const LANGUAGES: { title: string; lang: Language }[] = [
  { title: 'English', lang: 'en' },
  { title: 'Русский', lang: 'ru' },
];

export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const THREE_DAYS_FROM_NOW = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);

export const LANGUAGE_TO_LOCALE_STRING_MAP: Record<Language, string> = {
  en: 'en-US',
  ru: 'ru-RU',
};

export const WITHDRAWAL_COMMISSION = 20;

export const DAILY_COOKIES_FEED_COUNT = 10;

export const FEED_XP_GAINED = 25;

export const ONE_DAY_MS = 1000 * 60 * 60 * 24;
export const ONE_WEEK_MS = ONE_DAY_MS * 7;

export const FEED_COOLDOWN_HOURS = 12;

export const TWELVE_HOURS_MS = ONE_DAY_MS / 2;

export const DAY_TO_REWARD_MAP: Record<StreakDay, number> = {
  1: 1,
  2: 2,
  3: 4,
  4: 6,
  5: 10,
  6: 14,
  7: 20,
};

export const FORTUNE_WHEEL_SEGMENTS: FortuneWheelSegmentsType[] = [
  { value: 'card', chance: 0, type: 'card' },
  { value: '200', chance: 1, type: 'cookie' },
  { value: 'camping', chance: 0, type: 'building' },
  { value: '100', chance: 3, type: 'cookie' },
  { value: 'camping', chance: 0, type: 'upgrade' },
  { value: 'prediction', chance: 0, type: 'prediction' },
  { value: '10', chance: 40, type: 'cookie' },
  { value: '1', chance: 0.7, type: 'ton' },
  { value: '20', chance: 40, type: 'cookie' },
  { value: '2', chance: 0.3, type: 'ton' },
  { value: '50', chance: 15, type: 'cookie' },
  { value: 'earth', chance: 0, type: 'building' },
];

export const USER_AGREEMENT_TRANSLATION_KEYS = [
  'intro',
  'goal',
  'account',
  'ton',
  'income',
  'info',
  'rules',
  'respect',
  'final',
];

export const EXCHANGE_RATES: Record<PriceType, number> = {
  [PriceType.TON]: 1,
  [PriceType.COOKIE]: 200,
};

export const MIN_DEPOSIT_TON = 1;
export const MIN_DEPOSIT_COOKIE = EXCHANGE_RATES[PriceType.COOKIE] * MIN_DEPOSIT_TON;
